<template>
  <div
    class="pack-mockups"
    :style="`background-color: var(--fa-${iconPack().theme.primary});`"
  >
    <div
      v-for="(mockup, index) in mockups"
      :key="`${mockup.image}-${index}`"
      :class="`pack-mockup pack-mockup-${index}`"
    >
      <img
        :src="`/images/icons/packs/${iconPack().name}/${mockup.image}`"
        :alt="mockup.altText ? mockup.altText : ''"
        aria-hidden
        class="pack-mockup-image"
      />
    </div>
  </div>
</template>

<script>
  const iconPackData = require('../iconPackData.json')

  export default {
    name: 'PackMockups',

    inject: ['iconPack'],

    computed: {
      mockups() {
        return this.iconPackData['mockups']
      },

      iconPackData() {
        const data = iconPackData.filter((p) => {
          return p.name === this.iconPack().name
        })[0]

        return data
      }
    }
  }
</script>
